import { onUnmounted, ref, watch } from 'vue'

export function useIdleTimeout(name: string, ms: number) {
  const events = ['mousemove', 'mousedown', 'resize', 'keydown', 'touchstart', 'wheel']
  let timer = 0
  let idle = ref(false)

  function start() {    
    console.log('useIdleTimeout.start', { name, ms })
    reset()
    for (const event of events) {
      window.addEventListener(event, reset, false)
    }    
  }

  function stop() {
    console.log('useIdleTimeout.stop', { name, ms })
    clearInterval(timer)
    for (const event of events) {
      window.removeEventListener(event, reset)
    }
  }

  function reset() {
     console.log('useIdleTimeout.reset', { name, ms })
    clearInterval(timer)
    idle.value = false
    timer = setTimeout(() => {
      idle.value = true
      stop()
    }, ms)
  }

  function onIdleTimeout(handle: () => void) {
    // console.log('useIdleTimeout.onIdleTimeout', { name })
    watch(idle, () => {
      if (idle.value) {
        handle()
      }
    })
  }

  //-----------------------------------------------------------

//   watch(idle, () => {
//     if (idle.value) {
//       console.log('idleTimeoutTrigger', { name, ms })
//     }
//   })

  onUnmounted(() => {
    stop()
  })

  //-----------------------------------------------------------
  return {
    start,
    stop,
    reset,
    onIdleTimeout,
  }
}
